import React from "react";
import {Field, reduxForm} from "redux-form";
import saveProfile from "../../../../img/profileImg/saveProfile.png";
import {Input} from "../../../../Utilits/Fields";

const EditModeProfileContacts = (props) => {
    return(
        <form onSubmit={props.handleSubmit} className='list-about-meEdit'>
            {props.error ?
                <p className='login__full_error full_error main-text'>{props.error}</p> : null
            }
            <button className="profile__button-edit-profile"><img src={saveProfile} alt=""/></button>
            {Object.keys(props.contact).map(network => {
                return (
                    <div key={network} className="profile__list-about-profile profile__network input-style1 profile__input-style1">
                        <div className='main-text'><img src={require("../../../../img/profileImg/" + network + ".png")} alt=""/>{network}:</div>
                        <div className="additional-text"><Field name={'contacts.' + network} component={Input} placeholder="Введите адрес"/></div>
                    </div>)

            })}
        </form>
    )
};

export default reduxForm({form: "socialNetworks"})(EditModeProfileContacts)